export default __webpack_public_path__ + "static/media/oggi3.a15e23bd.jpg";